import * as React from 'react'
import { SelectOption, FilterOnChange, FilterFetchOptions } from '../FilterGroup.types'
import { Select } from 'antd-v4'
import { SelectProps, SelectValue } from 'antd-v4/lib/select'

import DebounceFetch from './DebounceFetch'

interface SelectFilterDropdownProps<T extends SelectValue | SelectOption[]>
  extends Omit<SelectProps<T>, 'options'> {
  debounceTimeout?: number
  async?: boolean
  label: string
  width?: number | '100%'
  value?: T
  placeholder?: string
  allowClear?: boolean
  onChange?: FilterOnChange<T, any>
  options: any
  fetchOnMount?: boolean
  useCustomTheme?: boolean
}

/**
 * Filter Field Component
 *
 * @returns {JSX.Element} - Returns Filter Field Component
 * @todo maybe move to shared folder
 */
export function SelectFilterDropdown<T extends SelectValue>({
  async = false,
  label,
  width,
  placeholder = 'Select...',
  allowClear = true,
  onChange,
  options,
  fetchOnMount,
  debounceTimeout,
  useCustomTheme = true,
  ...rest
}: SelectFilterDropdownProps<T>) {
  const selectProps: SelectProps<T> = {
    showSearch: true,
    style: { width: width },
    placeholder,
    allowClear,
    optionFilterProp: 'label',
    onChange,
    className: useCustomTheme ? 'filter-dropdown-input' : undefined,
    dropdownClassName: useCustomTheme ? 'filter-dropdown-options' : undefined,
    ...rest,
  }
  return (
    <div className='mr-2 filter-dropdown' style={{ width }}>
      <label>{label}</label>
      <div className={'filter-dropdown-input-wrapper'}>
        {async ? (
          <DebounceFetch<T>
            fetchOptions={options as FilterFetchOptions}
            fetchOnMount={fetchOnMount}
            debounceTimeout={debounceTimeout}
            render={(data: SelectProps<T>) => <Select<T> {...selectProps} {...data} />}
          />
        ) : (
          <Select<T>
            {...selectProps}
            options={options}
            notFoundContent={'No results found'}
            dropdownMatchSelectWidth={false}
          />
        )}
      </div>
    </div>
  )
}
